import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Video } from "lucide-react";

export default function DoctorDashboard() {
  const { user } = useAuth();
  const [apts, setApts] = useState([]);
  useEffect(() => { api.get("/appointments").then((r) => setApts(r.data)); }, []);

  const upcoming = apts.filter(a => new Date(a.slot_time) >= new Date(Date.now() - 3600_000));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="text-xs font-semibold uppercase tracking-widest text-teal-700">Doctor dashboard</div>
      <h1 className="font-display text-3xl sm:text-4xl font-bold mt-1">Dr. {user?.name}</h1>
      <div className="text-slate-600 text-sm">{user?.specialization}</div>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <Card className="p-5 rounded-2xl" data-testid="stat-total-apts">
          <div className="text-xs uppercase text-slate-500">Total appointments</div>
          <div className="font-mono text-3xl font-bold">{apts.length}</div>
        </Card>
        <Card className="p-5 rounded-2xl">
          <div className="text-xs uppercase text-slate-500">Upcoming</div>
          <div className="font-mono text-3xl font-bold">{upcoming.length}</div>
        </Card>
        <Card className="p-5 rounded-2xl">
          <div className="text-xs uppercase text-slate-500">Video consultations</div>
          <div className="font-mono text-3xl font-bold">{apts.filter(a => a.mode === "video").length}</div>
        </Card>
      </div>

      <Card className="p-5 rounded-2xl mt-6" data-testid="doctor-schedule">
        <div className="font-display font-bold mb-3">My schedule</div>
        {apts.length === 0 && <div className="text-sm text-slate-500 py-8 text-center">No appointments yet</div>}
        {apts.map((a) => (
          <div key={a.id} className="flex items-center justify-between py-3 border-b last:border-0">
            <div>
              <div className="font-semibold">{a.patient_name}</div>
              <div className="text-xs text-slate-500">{new Date(a.slot_time).toLocaleString()} · {a.reason || "—"}</div>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="capitalize">{a.mode.replace("_", " ")}</Badge>
              {a.mode === "video" && a.video_room && (
                <Link to={`/video/${a.video_room}`}>
                  <Button size="sm" variant="outline"><Video className="w-4 h-4 mr-1" />Join</Button>
                </Link>
              )}
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
